export default __webpack_public_path__ + "static/invoiceListPaid-75abe0f54b109274243c7154b4fdca11.webp";